var map = {
	"./ChatGPT Image Feb 27, 2026, 01_10_15 PM.png": 9281,
	"./ChatGPT Image Feb 27, 2026, 12_39_24 PM.png": 6758,
	"./ChatGPT Image Feb 27, 2026, 12_43_18 PM.png": 8614,
	"./ChatGPT Image Feb 27, 2026, 12_57_33 PM.png": 7742,
	"./helaya kandy.jpg": 2479,
	"./unnamed.webp": 6866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9742;